import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './src/App';
const rootElement = document.getElementById('root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<App data-id="element-0" />);
}